module.exports = __webpack_public_path__ + "media/application/images/svgs/skip-forward-f9da82b23cd6bff61720d53eaef70cab.svg";